<template>
  <Modal title="生成推广链接"
         v-model="isCreateLink"
         class-name="vertical-center-modal">
    <div class="form-group">
      <div class="label-wrap">
        推广位链接
      </div>
      <div class="form-item-wrap">
        <input type="text"
               placeholder="推广链接"
               readonly="isReadOnly"
               v-model="link" />
      </div>
      <div class="btn-copy-wrap">
        <span class="btn"
              @click="copyLink">
          复制链接
        </span>
      </div>
    </div>
    <div class="form-group" style="align-items: flex-start">
      <div class="label-wrap">
        推广海报
      </div>
      <div class="form-item-wrap no-border">
        <img :src="poster64"  />
        <div class="btn-dowload-wrap">
          <a class="btn" :href="poster64" download="邀请海报.jpg">下载海报</a>
        </div>
      </div>
    </div>
    <div slot="footer">
      <div class="footer-wrapper">

      </div>
    </div>
    <Spin size="large"
          fix
          v-show="loading"></Spin>
  </Modal>
</template>
<script>
import { Modal,Spin } from 'view-design'
import { requestAjax } from '@/api/user'
export default {
  name: "GetLinked",
  components: {
    Modal,
    Spin
  },
  data: function () {
    return {
      isCreateLink: false,
      link: '',
      isReadOnly: true,
      poster:'',
      poster64:'',
      loading:true
    }
  },
  methods: {
    init: function (isCreateLink, row) {
      this.loading = true
      this.isCreateLink = isCreateLink
      this.link = row.h5_link
      // this.poster = row.h5_share_poster
      this.poster = ''
      this.poster64 = ''
      this.getDownloadImg(row)
    },
    copyLink: function () {
      var that = this
      this.$copyText(this.link).then(function (e) {
        that.$Message.success('复制成功')
        console.log(e)
      }, function (e) {
        that.$Message.error('复制失败,请升级浏览器版本！')
        console.log(e)
      })
    },
    getDownloadImg(row){
        var that =this;
        requestAjax({app_key:row.app_key}, '/index/promotion/downloadImg', 'post').then(function (response) {
            if(response.code == 200){
                that.poster = response.data.img_url
                that.poster64 = response.data.base64
                that.loading =false
            }else{
                that.loading =false
                that.$Message.error(response.msg)
            }

        })
    },
    downLoad(){
        // 下载图片地址和图片名
        var name ='邀请海报'
        const image = new Image();
        image.setAttribute('crossOrigin', 'anonymous');
        // 解决跨域 Canvas 污染问题
        // eslint-disable-next-line func-names
        image.onload = function () {
            const canvas = document.createElement('canvas');
            canvas.width = image.width;
            canvas.height = image.height;
            const context = canvas.getContext('2d');
            context.drawImage(image, 0, 0, image.width, image.height);
            const url = canvas.toDataURL('image/png'); // 得到图片的base64编码数据
            const a = document.createElement('a'); // 生成一个a元素
            a.download = name || 'photo'; // 设置图片名称
            a.href = url; // 将生成的URL设置为a.href属性
            a.click();
        };
        image.src = this.poster+'?time='+new Date().valueOf();

    }
  }
}
</script>

<style scoped>
>>> .vertical-center-modal {
  display: flex;
  align-items: center;
  justify-content: center;
}
>>> .vertical-center-modal .ivu-modal {
  top: 0;
}
>>> .vertical-center-modal .form-group {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  min-width: 0;
  width: 100%;
  margin-bottom: 0.4rem;
}
.vertical-center-modal .form-group .label-wrap {
  font-size: 14px;
  color: #333333;
  letter-spacing: 0;
  width: 1.4rem;
  text-align: right;
  margin-right: 0.32rem;
  font-weight: 600;
}
.vertical-center-modal .form-group .form-item-wrap {
  flex: 1;
  min-width: 0;
  border: 1px solid #eeeeee;
  border-radius: 2px;
  overflow: hidden;
}
.vertical-center-modal .form-group .form-item-wrap.no-border {
  border: none;
}
.vertical-center-modal .form-group .form-item-wrap input {
  padding: 0.13rem 0.2rem;
  width: 100%;
  letter-spacing: 0;
  font-size: 14px;
  color: #333333;
}

.vertical-center-modal .form-group .form-item-wrap input:-ms-input-placeholder {
  font-size: 14px;
  color: #c1c1c1;
  letter-spacing: 0;
}
.vertical-center-modal .form-group .form-item-wrap input::-moz-placeholder {
  /* Mozilla Firefox 19+ */
  font-size: 14px;
  color: #c1c1c1;
  letter-spacing: 0;
}
.vertical-center-modal .form-group .form-item-wrap img {
  max-width: 50%;
}
.vertical-center-modal
  .form-group
  .form-item-wrap
  input::-webkit-input-placeholder {
  font-size: 14px;
  color: #c1c1c1;
  letter-spacing: 0;
}
.vertical-center-modal .form-group .btn-copy-wrap .btn {
  margin-left: 0.4rem;
  font-size: 14px;
  color: #ff8622;
  text-align: center;
  padding: 0.16rem 0.44rem;
  border: 1px solid #ff8622;
  border-radius: 2px;
  cursor: pointer;
}
>>> .vertical-center-modal .ivu-modal-footer {
  border-top: none;
  padding: none;
  text-align: right;
}
.vertical-center-modal .form-group .btn-dowload-wrap {
  margin-top: 0.54rem;
}
.vertical-center-modal .form-group .btn-dowload-wrap .btn {
  background: #ff8622;
  border-radius: 2px;
  color: #fff;
  display: inline-block;
  font-size: 16px;
  padding: 0.14rem 0.44rem;
  cursor: pointer;
}
</style>



// WEBPACK FOOTER //
// src/views/pc/promotion/manage/modal/GetLinked.vue